<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Parámetros Para CIS
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-form ref="form_parametro_cis">
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objForm.idAseguradora"
                            item-text="aseguradora" item-value="idAseguradora" @change="onListarSeguros"
                            :items="listGeneral.listAseguradora" outlined dense :rules="requeridoRegla" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="objForm.idSeguro"
                            @change="onListarProductos" :items="listGeneral.listSeguro" item-value="idSeguro"
                            item-text="seguro" :rules="requeridoRegla" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Producto *" color="textbox" v-model="objForm.idProducto"
                            :items="listGeneral.listProducto" item-value="id_producto" item-text="nombre_producto" outlined dense
                            :rules="requeridoRegla" @change="onListarParametroCIS" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Número de Registro SCVS *" color="textbox"
                            v-model.trim="objForm.nroRegistroSCVS" :rules="requeridoRegla" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="datePicker" v-model="openDatePicker" :return-value.sync="objForm.fechaRegistroSCVS"
                            persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objForm.fechaRegistroSCVS"
                                    label="Fecha de Registro SCVS*" :rules="requeridoRegla" prepend-inner-icon="event"
                                    readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objForm.fechaRegistroSCVS" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="openDatePicker = false" v-text="'Salir'"> </v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.datePicker.save(objForm.fechaRegistroSCVS)" v-text="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objForm.idEstado"
                            :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado"
                            :rules="requeridoRegla" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-textarea label="Leyenda 1 *" color="textbox" v-model.trim="objForm.leyenda1"
                            :value="objForm.leyenda1" counter="200" :rules="_.concat(requeridoRegla,max200Regla)" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-textarea label="Leyenda 2 *" color="textbox" v-model.trim="objForm.leyenda2"
                            :value="objForm.leyenda2" counter="200" :rules="_.concat(requeridoRegla,max200Regla)" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-text-field label="Frase de Resolución *" color="textbox" v-model.trim="fraseResolucion" readonly
                            outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-checkbox v-model="objForm.horaFijaCis" color="primary" label="Hora Fija CIS" dense
                            :rules="parseInt(objForm.idTipoVenciCis) != listParametro.idTipoVencimientoCisHora ? requeridoRegla : []">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="datePickerDesde" v-model="datePickerFecha.openDatePickerDesde" :return-value.sync="objForm.horaCisDesde" persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objForm.horaCisDesde" label="Desde *"
                                    :rules="parseInt(objForm.idTipoVenciCis) != listParametro.idTipoVencimientoCisHora ? requeridoRegla : []"
                                    prepend-inner-icon="access_time" readonly outlined dense v-on="on" :disabled="disabledHora" />
                            </template>
                            <!-- <v-date-picker color="primary" v-model="objForm.horaCisDesde" scrollable locale="es"> -->
                            <v-time-picker v-if="datePickerFecha.openDatePickerDesde" v-model="objForm.horaCisDesde" full-width>
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="datePickerFecha.openDatePickerDesde = false" v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.datePickerDesde.save(objForm.horaCisDesde)" v-html="'Guardar Hora'"></v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="datePickerHasta" v-model="datePickerFecha.openDatePickerHasta" :return-value.sync="objForm.horaCisHasta" persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objForm.horaCisHasta" label="Hasta *"
                                    :rules="parseInt(objForm.idTipoVenciCis) != listParametro.idTipoVencimientoCisHora ? requeridoRegla : []"
                                    prepend-inner-icon="access_time" readonly outlined dense v-on="on" :disabled="disabledHora" />
                            </template>
                            <!-- <v-date-picker color="primary" v-model="objForm.horaCisHasta" scrollable locale="es"> -->
                            <v-time-picker v-if="datePickerFecha.openDatePickerHasta" v-model="objForm.horaCisHasta" full-width>
                                <v-spacer></v-spacer>
                                <v-btn outlined rounded color="danger" @click="datePickerFecha.openDatePickerHasta = false" v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary" @click="$refs.datePickerHasta.save(objForm.horaCisHasta)" v-html="'Guardar Hora'"></v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="2">
                        <v-radio-group v-model="objForm.fechaVencimiento" dense>
                            <v-radio label="Fecha de Vencimiento Fijo" color="primary" value="S" :rules="requeridoRegla"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-radio-group v-model="objForm.idTipoVenciCis" row dense>
                            <v-radio v-for="(item,index) in listGeneral.listTipoVencimiento" :key="index" :label="item.tipoVenciCis" color="primary" 
                                    :value="item.idTipoVenciCis" :disabled="objForm.fechaVencimiento != 'S'">
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="Recarga Tasa *" color="textbox" v-model="objForm.valorTasaRec" :rules="_.concat(requeridoRegla,decimal)" 
                                    outlined dense :disabled="objForm.fechaVencimiento != 'S'"/>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="Número Tiempo Vencimiento *" color="textbox" v-model="objForm.nroTiempoVenciCis" :rules="_.concat(requeridoRegla)" 
                                    outlined dense :disabled="objForm.fechaVencimiento != 'S'"/>
                    </v-col>
                </v-row>
                <v-row dense class="mt-5">
                    <v-col cols="12">
                        <v-row dense>
                            <v-col class="text-center">
                                <v-btn rounded dark color="primary" @click="insertarActualizar(true)" v-html="'Guardar'" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-card>
</template>
 <script>
    export default {
        name: 'ParametroCISView',
        data: () => ({
            datePickerFecha: { openDatePickerDesde: false, openDatePickerHasta: false },
            openDatePicker: false,
            listGeneral :{},
            listParametro: {},
            objForm: {
                idAseguradora:null,
                idSeguro:null,
                horaFijaCis: false,
                idProducto:null,
                nroRegistroSCVS:null,
                fechaRegistroSCVS: moment().format('YYYY-MM-DD'),
                idEstado:null,
                leyenda1:null,
                leyenda2:null,
                idTipoVenciCis:false,
                horaCisDesde: null,
                horaCisHasta: null,
                fechaVencimiento: '70',
                idTipoVenciCis: null,
                valorTasaRec:0,
                nroTiempoVenciCis:0
            }
        }),
        created(){
            axios.post(`${BASE_URI}administrador/parametro-cis/cargaGeneral`,{})
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw r.data.mensaje;
                        this.listGeneral               = r.data.data.listas;
                        this.listParametro             = r.data.data.parametros;
                        this.objForm.idAseguradora     = this.listGeneral.listAseguradora[0].idAseguradora;
                        this.objForm.idEstado          = _.toString(this.listParametro.idEstadoDefault);
                        this.onListarSeguros('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 });
        },  
        computed:{
            fraseResolucion(){
                return _.get(this.objForm,'leyenda1','')+' '+_.get(this.objForm,'nroRegistroSCVS','')+' '+_.get(this.objForm,'leyenda2','')+' '+moment(this.objForm.fechaRegistroSCVS).format('DD-MM-YYYY');
            },
            disabledHora(){
                var band = false;
                if(!this.objForm.horaFijaCis)
                    band = true;            
                if(this.objForm.horaFijaCis && (parseInt(this.objForm.idTipoVenciCis) == this.listParametro.idTipoVencimientoCisHora))
                    band = true;            
                return band;
            }
        },
        methods:{
            onListarSeguros(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                        "opcion"        : "L_SEGURO_X_ASEGURADORA",
                        "idAseguradora" : _.get(this.objForm,'idAseguradora',null),
                        idTipoPoliza    : this.listParametro.id_tipo_poliza_maestra,
                        "idEstado"      : _.get(this.listParametro,'idEstadoDefault',null)
                    };
                    this.$set(this.listGeneral,'listSeguro',[]);
                    this.$set(this.objForm,'idSeguro',null);
                    this.$set(this.objForm,'idProducto',null);
                    this.$set(this,'objForm',_.merge({},_.pick(this.objForm,['idAseguradora','idEstado']),{fechaRegistroSCVS: moment().format('YYYY-MM-DD')}));
                    this.$refs.form_parametro_cis.resetValidation();

                    axios.post(`${BASE_URI}administrador/poliza/listar`,objeto)
                        .then((r) => {
                            if(r.status != 200) throw mensajeEstandar.errorPeticion;
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw r.data.mensaje;
                                this.$set(this.listGeneral,'listSeguro',r.data.data);
                        })
                        .catch((e) => {
                            mensajesAlerta(e,'E');
                        })
                }
            },
            onListarProductos(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                        "opcion"        : "L_COMBO",
                        "idAseguradora" : _.get(this.objForm,'idAseguradora',null),
                        "idSeguro"      : _.get(this.objForm,'idSeguro',null),
                        "idEstado"      : _.get(this.listParametro,'idEstadoDefault',null)
                    };

                    this.$set(this.listGeneral,'listProducto',[]);
                    this.$set(this.objForm,'idProducto',null);
                    this.$refs.form_parametro_cis.resetValidation();
                    this.$set(this,'objForm',_.merge({},_.pick(this.objForm,['idAseguradora','idSeguro','idEstado']),{fechaRegistroSCVS: moment().format('YYYY-MM-DD')}));

                    axios.post(`${BASE_URI}administrador/producto/listar`,objeto)
                        .then((r) => {
                            if(r.status != 200) throw mensajeEstandar.errorPeticion;
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw r.data.mensaje;
                                this.$set(this.listGeneral,'listProducto',r.data.data);
                        })
                        .catch((e) => {
                            mensajesAlerta(e,'E');
                        });
                }
            },
            onListarParametroCIS(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                        "opcion"        : "LISTAR",
                        "idProducto"    : _.get(this.objForm,'idProducto',null),
                        "idEstado"      : _.get(this.listParametro,'idEstadoDefault',null)
                    };
                    
                    axios.post(`${BASE_URI}administrador/parametro-cis/listar`,objeto)
                        .then((r) => {
                            if(r.status != 200) throw mensajeEstandar.errorPeticion;
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) throw r.data.mensaje;
                                this.objForm = _.merge({},this.objForm,r.data.data[0]);
                                this.objForm.horaFijaCis = parseInt(r.data.data[0].horaFijaCis) > 0 ? true : false;
                        })
                        .catch((e) => {
                            mensajesAlerta(e,'E');
                        });
                }
            },
            insertarActualizar(event){
                if(!_.isUndefined(event)){
                    try {
                        if(!this.$refs.form_parametro_cis.validate()) throw mensajeEstandar.corregirInformacion;
                        if(_.isNull(_.get(this.objForm,'idTipoVenciCis',null))) throw mensajeEstandar.corregirInformacion;
                        if(parseInt(this.objForm.idTipoVenciCis) != this.listParametro.idTipoVencimientoCisHora)
                            if(this.objForm.horaCisDesde > this.objForm.horaCisHasta) throw mensajeEstandar.corregirInformacion;
                        
                        if(parseInt(this.objForm.idTipoVenciCis) == this.listParametro.idTipoVencimientoCisHora ){
                            this.objForm.horaCisDesde = null;
                            this.objForm.horaCisHasta = null;
                            this.objForm.horaFijaCis  = false;
                        }

                        var lista = _.merge({},_.omit(this.objForm,['idAseguradora','idSeguro']),{opcion: _.isNull(_.get(this.objForm,'idSecPar',null)) ? 'I' : 'U' });

                        axios.post(`${BASE_URI}administrador/parametro-cis/insertOrUpdate`,lista)
                            .then((r) => {
                                if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) throw r.data.mensaje;
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    this.onListarParametroCIS('L');
                            })
                            .catch((e) => {
                                mensajesAlerta(e,'E');
                            });
                    } catch (error) {
                        mensajesAlerta(error,'I');
                    }
                }
            }
        }
    }
 </script>